/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Office_Ai_HintInputs */

const cs_settings_office_ai_hint = /** @type {(inputs: Settings_Office_Ai_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Když je vypnuto, AI nástroje se skryjí. Kredity se i tak počítají jen za AI.`)
};

const en_settings_office_ai_hint = /** @type {(inputs: Settings_Office_Ai_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When off, AI tools are hidden. Credit metering still only applies to AI usage.`)
};

/**
* | output |
* | --- |
* | "When off, AI tools are hidden. Credit metering still only applies to AI usage." |
*
* @param {Settings_Office_Ai_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_office_ai_hint = /** @type {((inputs?: Settings_Office_Ai_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Office_Ai_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_office_ai_hint(inputs)
	return cs_settings_office_ai_hint(inputs)
});